import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const sellScreenCheckoutStyle = StyleSheet.create({
    saleOuterView: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    addCustomerOuterView: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    },
    addCustomerInnerView: {
        flexDirection: "row",
        alignItems: "center",
        borderWidth: 0.3,
        borderColor: appColors?.grey,
        justifyContent: "center",
        padding: 10,
        borderRadius: 5,
        backgroundColor: appColors?.buttonColor,
        flexWrap: "wrap",
    },
    customerProfileView: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#f8f8f8",
        borderWidth: 0.3,
        borderColor: appColors?.grey,
        borderRadius: 5,
        padding: 10,
        paddingHorizontal: 20
    },
    avatarTitleStyle: {
        fontFamily: appFonts?.bold,
        color: appColors?.light,
        fontSize: fontSize?.mediumFontSize
    },
    avatarContainerStyle: {
        backgroundColor: appColors?.primary,
        // borderRadius: 40,
        marginRight: 10,
    },
    saleButtonView: {
        flexDirection: "row",
        alignItems: "center",
        gap: 10
    },
    productCartView: {
        gap: 15
    },
    productCartInnerView: {
        backgroundColor: appColors?.light,
        borderRadius: 5,
        gap: 10,
        padding: 7
    },
    productFirstView: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        flex: 1
    },
    productNameView: {
        flexWrap: "wrap",
        width: "65%"
    },
    productTotalView: {
        width: "30%",
        alignItems: "flex-end"
    },
    productSecondView: {
        flexDirection: "row",
        justifyContent: "flex-start"
    },
    inputOuterView: {
        alignItems: "center",
        width: "100%"
    },
    leftIconContainerStyle: {
        borderRightWidth: 0.34,
        borderRightColor: appColors?.lightGrey,
        paddingLeft: 5
    },
    qtyLeftIconContainerStyle: {
        borderRightWidth: 0.34,
        borderRightColor: appColors?.lightGrey,
        width: "25%",
        overflow: "hidden"
    },
    rightIconContainerStyle: {
        borderLeftWidth: 0.34,
        borderLeftColor: appColors?.lightGrey,
        width: "25%",
        overflow: "hidden"
    },
    qtyInputStyle: {
        fontFamily: appFonts?.bold,
        fontSize: fontSize?.smallerFontSize,
        color: appColors?.lightDark
    },
    qtyButtonView: {
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center"
    },
    productContainerView: {
        height: 45,
        paddingHorizontal: 0,
        paddingVertical: 0
    },
    productPriceInputStyle: {
        fontFamily: appFonts?.bold,
        fontSize: fontSize?.smallerFontSize,
        color: appColors?.lightDark,
        marginStart: 7
    },
    popoverStyle: {
        backgroundColor: appColors?.light,
        borderRadius: 5,
        elevation: 8,
        shadowColor: "#000",
        shadowOpacity: 0.3,
        shadowRadius: 4.65,
        shadowOffset: { height: 4, width: 0 }
    },
    moreOptionView: {
        borderRadius: 10,
        marginLeft: 5,
        backgroundColor: appColors?.lightBackgroundColor,
        justifyContent: "center",
        alignItems: "center"
    },
    productThirdView: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        flex: 1
    },
    productNotesView: {
        flexWrap: "wrap",
        width: "40%"
    },
    productSoldView: {
        width: "40%",
        alignItems: "flex-end"
    },
    productNotesInnerView: {
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        gap: 5
    },
    productCouponOuterView: {
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 10,
        flex: 1,
        marginRight: 2
    },
    couponSelectView: {
        flex: 1,
        flexDirection: "row",
        justifyContent: "center",
        gap: 10,
        borderRadius: 5,
        paddingHorizontal: 20,
        backgroundColor: appColors?.buttonColor,
        borderWidth: 0.3,
        borderColor: appColors?.statusTextForOrder,
        padding: 10
    },
    couponUnSelectView: {
        flexDirection: "row",
        borderWidth: 0.3,
        backgroundColor: appColors?.buttonColor,
        justifyContent: "center"
    },
    customerNotesView: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        padding: 10,
        borderRadius: 5,
        backgroundColor: appColors?.light,
    },
    orderNotesView: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: 10,
        borderRadius: 5,
        gap: 5,
        backgroundColor: appColors?.light,
    },
    orderSummaryOuterView: {
        backgroundColor: appColors?.light,
        padding: 10,
        gap: 5,
        borderRadius: 5
    },
    orderSummaryFirstView: {
        flex: 0.7,
        alignItems: "flex-start"
    },
    orderSummmarySecondView: {
        flexDirection: "row",
        alignItems: "center",
        flex: 0.3,
        justifyContent: "flex-end"
    },
    discountTitleView: {
        flex: 1,
        flexDirection: "row",
        alignItems: "center"
    },
    orderTotalView: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingBottom: 5,
    },
    loyaltyView: {
        alignItems: "center"
    },
    clearCartView: {
        alignSelf: "flex-start",
        zIndex: 10000,
        paddingBottom: 30
    },
    modalInnerView: {
        paddingTop: 20,
        paddingHorizontal: 20,
        paddingBottom: 0
    },
    customerListView: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        margin: 7,
        marginHorizontal: 10,
        borderWidth: 0.3,
        borderColor: appColors?.grey,
        padding: 5,
        paddingHorizontal: 10,
        borderRadius: 5
    },
    updateButtonStyle: {
        backgroundColor: appColors?.primary,
        borderRadius: 5,
        alignSelf: "flex-start",
        paddingHorizontal: 5
    }
})






